// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalUpdate_root__25SPO","footer":"ModalUpdate_footer__2CMQ_"};